import * as React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import {Action, Secondary} from '../../../../../system/buttons';
import {
  DIXPER_CONNECTED,
  DIXPER_DISCONNECTED,
  DIXPER_FAILED,
  DIXPER_RECONNECTING,
} from '../../../../../dixper/DixperInteractor';

export class DixperStatus extends React.Component {
  state = {};

  render() {
    return (
      <Form.Group as={Row}>
        <Form.Label column sm="2">
          Voicemod status
        </Form.Label>
        <Col sm="2" className={'d-flex align-items-center'}>
          {this.mapVoicemodStatus(this.getInteractor().status)}
        </Col>
        <Col>
          {this.getInteractor().status === DIXPER_CONNECTED
            ? this.DisconnectButton()
            : ''}
          {this.getInteractor().status === DIXPER_FAILED
            ? this.ConnectButton()
            : ''}
          {this.getInteractor().status === DIXPER_RECONNECTING
            ? this.StopReconnectButton()
            : ''}
          {this.getInteractor().status === DIXPER_DISCONNECTED
            ? this.ConnectButton()
            : ''}
        </Col>
      </Form.Group>
    );
  }

  handleUpdateFromVoicemodInteractor = (voicemodeStatus) => {
    this.setState({voicemodeStatus});
  };

  ConnectButton = () => {
    return (
      <Action
        onClick={() => {
          this.getInteractor().connect(this.handleUpdateFromVoicemodInteractor);
        }}
      >
        Connect
      </Action>
    );
  };
  DisconnectButton = () => {
    return (
      <Secondary
        onClick={() => {
          this.getInteractor().disconnect();
        }}
      >
        Disconnect
      </Secondary>
    );
  };

  StopReconnectButton = () => {
    return (
      <Secondary
        onClick={() => {
          this.getInteractor().disconnect();
        }}
      >
        Stop reconnecting
      </Secondary>
    );
  };

  getInteractor = () => this.props.interactor;

  mapVoicemodStatus = (status) => {
    return {
      DIXPER_CONNECTED: 'Dixper is connected',
      DIXPER_DISCONNECTED: 'Dixper is not connected',
      DIXPER_CONNECTING: 'Dixper is connecting',
      DIXPER_RECONNECTING: 'Dixper is reconnecting',
      DIXPER_FAILED: 'Dixper connection failed',
    }[status];
  };
}
